import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddressSearchComponent } from './address-search/pages/address-search/address-search.component';
import { NoRouteFoundPageComponent } from './shared/components/no-route-found-page/no-route-found-page.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { FeatureIsActiveGuard } from './shared/guards/feature-is-active.guard';
import { SwedishPortalGuard } from './shared/guards/portal.guard';
import { getNavigationUrl } from './shared/navigation/navigation-urls';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: getNavigationUrl().defaultRedirect,
  },
  {
    path: 'hub',
    canActivate: [AuthGuard],
    loadChildren: () => import('./hub/hub.module').then((m) => m.HubModule),
  },
  {
    path: 'kampanj',
    loadChildren: () =>
      import('./campaign/campaign.module').then((m) => m.CampaignModule),
  },
  {
    path: 'client-features',
    loadChildren: () =>
      import('./client-features/client-features.module').then(
        (m) => m.ClientFeaturesModule
      ),
  },
  {
    path: getNavigationUrl().order,
    children: [
      {
        path: 'fiber',
        data: { featureName: 'fiberModule' }, // Data for FeatureIsActiveGuard
        loadChildren: () =>
          import('./fiber/fiber.module').then((m) => m.FiberModule),
      },
      {
        path: getNavigationUrl().services,
        canActivate: [FeatureIsActiveGuard],
        data: { featureName: 'servicesModule' }, // Data for FeatureIsActiveGuard
        loadChildren: () =>
          import('./services/services.module').then((m) => m.ServicesModule),
      },
      {
        path: 'tjanster',
        redirectTo: 'tjänster',
      },
    ],
  },
  {
    path: 'fritidshus',
    canMatch: [SwedishPortalGuard],
    loadChildren: () =>
      import('./leisure-homes/leisure-homes.routes').then(
        (m) => m.LEISURE_HOME_ROUTES
      ),
  },
  {
    path: 'bestall',
    redirectTo: 'beställ',
  },
  {
    path: getNavigationUrl().addressSearch,
    canActivate: [FeatureIsActiveGuard, AuthGuard],
    data: { featureName: 'addressSearchModule' },
    component: AddressSearchComponent,
  },
  {
    path: 'hoppsan',
    component: NoRouteFoundPageComponent,
  },
  {
    path: '**',
    redirectTo: 'hoppsan',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
